// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__250SE","unreadBadge":"styles_unreadBadge__3wYGB","modalContent":"styles_modalContent__2lBSv","modal":"styles_modal__11XrK"};